// extracted by mini-css-extract-plugin
export default {"wrapper":"ResumeParticle_wrapper__1Z3No","title":"ResumeParticle_title__JtI7q","end-line":"ResumeParticle_end-line__ElX51"};